import React from 'react';
import PropTypes from 'prop-types';
import { PaperContent } from 'virtues-bootstrap';

import s from './styles.module.scss';

const PatientProfileInfo = ({ name, patientId }) => (
  <PaperContent>
    <div className={s.name} data-test="name">
      {name}
    </div>
    <div>RPM-CIED-{patientId}</div>
  </PaperContent>
);

PatientProfileInfo.defaultProps = {
  name: null,
};

PatientProfileInfo.propTypes = {
  name: PropTypes.string,
  patientId: PropTypes.string.isRequired,
};

export default PatientProfileInfo;
